import Area from './App.svelte';

export default AreaApp = Area;